"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Button_1 = require("@Components/Buttons/Button");
const ReviewStep = (props) => {
    const { header, onBack, onSubmit, selectedWriterName, children } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("h2", null, header),
        react_1.default.createElement("p", null, "Please review the information below to confirm it's correct before submitting your request."),
        react_1.default.createElement("div", { className: 'review-information' },
            react_1.default.createElement("div", null,
                react_1.default.createElement("p", null, "Songwriter Name: "),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null, selectedWriterName))),
            children),
        react_1.default.createElement("div", { className: 'footer-buttons' },
            react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'secondary', onClick: onBack }, "Back"),
            react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', onClick: onSubmit }, "Submit Request"))));
};
exports.default = ReviewStep;
